import { render, staticRenderFns } from "./poster.vue?vue&type=template&id=194f9b91&scoped=true&"
import script from "./poster.vue?vue&type=script&lang=js&"
export * from "./poster.vue?vue&type=script&lang=js&"
import style0 from "./poster.vue?vue&type=style&index=0&id=194f9b91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194f9b91",
  null
  
)

export default component.exports